module.exports = __webpack_public_path__ + "img/shape_polygon_l.d4162a25.svg";